import { createSlice } from "@reduxjs/toolkit";

import { markStates } from "utils/misc";

const initialState = {
  isSidebarOpen: true,
  language: "pl",
  colorThemeMode: "light",
  openMobileTopbar2: false,
  registerCurrentDeviceForm: "Android",
  whatsappwebchat: false,
  dashboardPage: {
    isDashboradComponent: true,
    appView: "",
    appName: "",
    appId: 0,
  },
  //   PMCList: [],
  //   PMSList: [],
  //   roleDetails: [],
};

export const uiSlice = createSlice({
  name: "ui",
  initialState,
  reducers: {
    resetUIStore: (state) => {
      markStates(initialState, state);
    },
    markUI: (state, action) => {
      markStates(action.payload, state);
    },
    toggleSidebar: (state) => {
      state.isSidebarOpen = !state.isSidebarOpen;
    },
  },
  extraReducers: (builder) => {},
});
export const { markUI, resetUIStore, toggleSidebar } = uiSlice.actions;

export const selectIsSidebarOpen = (state) => state.uiReducer.isSidebarOpen;
export const selectColorThemeMode = (state) => state.uiReducer.colorThemeMode;
export const selectlanguage = (state) => state.uiReducer.language;
export const selectwhatsappwebchat = (state) => state.uiReducer.whatsappwebchat;
export const selectDashboardPageView = (state) => state.uiReducer.dashboardPage;
export const selectOpenMobileTopbar2 = (state) =>
  state.uiReducer.openMobileTopbar2;
export const selectRegisterCurrentDeviceComponent = (state) =>
  state.uiReducer.registerCurrentDeviceForm;
export default uiSlice.reducer;
